// 請求世代計數（報告改版工單 14）：非同步流程「只有最新一次的結果算數」。
// 例：報告頁殼換報告時，舊一次 load() 的主報告或渲染器 chunk 晚回來，不得蓋掉新一次的結果。
// 純函式、不 import 任何模組（tests/report-shell.test.mjs 直接測）。元件把它放在非響應式欄位（created 內 this.x = …）。
//   const loads = createRequestGeneration()
//   const gen = loads.next()
//   await something
//   if (!loads.isCurrent(gen)) return   // 之後又開始了新的一次，丟掉這次的結果
export function createRequestGeneration () {
  let current = 0
  return {
    next () {
      current += 1
      return current
    },
    isCurrent (generation) {
      return generation === current
    },
  }
}
